import { IBasicTableRow } from '../components/BasicTable';
import officeholdersToObject from './officeholders-to-object';
import getVacantOfficeholders from './get-vacant-officeholders';

import { IOfficeholder, TGovBody } from '../../../types';
import { IFetcherResponse } from '../types';

function formatOfficeholderForTable(
  officeholder: IOfficeholder
): {
  body: TGovBody | null;
  familyName: string;
  givenName: string;
  nickname: string;
  party: string;
  title: string;
} {
  return {
    body: officeholder.body,
    familyName: officeholder.familyName,
    givenName: officeholder.givenName,
    nickname: officeholder.nickname,
    party: officeholder.party,
    title: officeholder.title,
  };
}

export default function formatBasicTable({
  officeholders,
  politicians,
}: IFetcherResponse): IBasicTableRow[] {
  const keyedOfficeholders = officeholdersToObject(officeholders);
  const vacantOfficeholders = getVacantOfficeholders(officeholders);

  const formattedData = politicians.map(politician => ({
    ...formatOfficeholderForTable(keyedOfficeholders[politician.id]),
    id: politician.id,
    slug: politician.slug,
  }));
  const formattedDataForVacants = vacantOfficeholders.map(officeholder => ({
    ...formatOfficeholderForTable(officeholder),
    id: Date.now(),
    slug: '',
  }));

  return [...formattedData, ...formattedDataForVacants];
}
